const GIG_GRID_XLRG = 1240;
const GIG_GRID_LRG = 899;
const GIG_GRID_MED = 750;
const GIG_GRID_SML = 530;

export const PLACEHOLDER_CLASS_NAME = 'personalized-content-placeholder';
export const DEFAULT_SLIDER_BASE_NUM = 5;
export const DEFAULT_SLIDER_BREAKPOINTS = [
    {
        breakpoint: GIG_GRID_XLRG,
        slides: 4,
        slidesToScroll: 4,
    },
    {
        breakpoint: GIG_GRID_LRG,
        slides: 3,
        slidesToScroll: 3,
    },
    {
        breakpoint: GIG_GRID_MED,
        slides: 2,
        slidesToScroll: 2,
    },
    {
        breakpoint: GIG_GRID_SML,
        slides: 1,
        slidesToScroll: 1,
    },
];
